import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildPerfVsIndexCapsuleConfigSlice } from './config/configslice';
import { PerfVsIndexCapsuleState } from './PerfVsIndexCapsuleState';
import { PerfVsIndexCapsuleActionPayload } from './actions';

const { reducer: configReducer } = buildPerfVsIndexCapsuleConfigSlice();

const perfVsIndexCapsuleWidgetReducer =
    combineReducers<PerfVsIndexCapsuleState>({
        config: configReducer,
    });

export const perfVsIndexCapsuleWidgetsReducer = createWidgetsReducer<
    PerfVsIndexCapsuleState,
    PerfVsIndexCapsuleActionPayload
>(WidgetType.PERF_VS_INDEX_CAPSULE, perfVsIndexCapsuleWidgetReducer);
